import { create } from "zustand";
import type { City } from "../../interfaces/exploreListingSearch";

interface SearchStore {
	searchValue: string;
	setSearchValue: (value: string) => void;
	searchResult: boolean;
	setSearchResult: (searchResult: boolean) => void;
	filteredResults: { city: City[] };
	setFilteredResults: (results: {
		city: City[];
	}) => void;
	isLoading: boolean;
	setLoading: (isLoading: boolean) => void;
}

const useSearchStore = create<SearchStore>((set) => ({
	searchValue: "",
	setSearchValue: (value) => set({ searchValue: value }),

	searchResult: false,
	setSearchResult: (openResultBox) => set({ searchResult: openResultBox }),

	filteredResults: { city: [] },
	setFilteredResults: (results) => set({ filteredResults: results }),

	isLoading: false,
	setLoading: (loading) => set({ isLoading: loading }),
}));

export { useSearchStore };
